/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { Region as ServerlessRegion } from '@modules/cluster-user-api/v1/types'
import type { Region as ClusterRegion } from '@modules/cloud-api/v1/types'
import type { PlatformId } from '@modules/ui-types'

/**
 * Converts cluster API Region objects to cloud API ClusterRegion objects
 * @param regions Array of cluster API Region objects
 * @returns Array of cloud API ClusterRegion objects
 */
export const convertToClusterRegions = (regions: ServerlessRegion[]): ClusterRegion[] =>
  regions.map((region) => ({
    identifier: region.id,
    name: region.name,
    features: [],
    ...('country_code' in region ? { country: region.country_code as string } : {}),
  }))

/**
 * Extracts platform IDs from cluster API Region objects
 * @param regions Array of cluster API Region objects
 * @returns Array of PlatformId values
 */
export const extractPlatformIds = (regions: ServerlessRegion[]): PlatformId[] =>
  regions.map((region) => region.csp as PlatformId)
